import { Component } from '@angular/core';
import { CouponService } from 'src/app/services/coupons/coupons.service';
import { ModalService } from 'src/app/services/modal/modal.service';

@Component({
  selector: 'app-coupon-modal',
  templateUrl: './coupon-modal.component.html',
  styleUrls: ['./coupon-modal.component.scss'],
})
export class CouponModalComponent {
  // Background image
  background = 'assets/images/coupon/qr_modal_fondo.jpg';
  
  // Products banner
  banner = 'assets/images/coupon/RN_PopUp_productos.png';
  
  // Red Numbers logo
  logo = 'assets/icons/rednumbers-logo-white.svg';


  coupon: any = {};

  couponDS: string = '30% OFF';

  // Texto a mostrar en el modal con el descuento
  discountText: string = '';

  constructor(
    private modal: ModalService<any>,
    private couponService: CouponService
  ) {
    this.couponService.getCouponObs$().subscribe(coupon => {
      this.coupon = coupon;

      // Preparar texto del descuento
      if (coupon) {
        const value: string = coupon.discount_value ?? '';
        // Si es porcentaje
        if (coupon.discount_type === 'percentage') {
          // Removemos decimales innecesarios
          const numericValue = parseFloat(value).toString();
          this.discountText = `${numericValue}% OFF`;
        } else {
          // Otro tipo de descuento: usamos símbolo dólar
          const numericValue = parseFloat(value).toString();
          this.discountText = `$${numericValue} OFF`;
        }
      }
    });
    // const duplicateResp = await this.couponService.getCoupon(codeToCheck, this.newCoupon.store_ids);
  }

  close() {
    this.modal.close();
  }
}